module.exports = __webpack_public_path__ + "static/media/iconTracking.027b8345.svg";